module.exports = __webpack_public_path__ + "img/product_107.df31d8b.webp";